import React from 'react';
import { useFieldHelper } from 'framework/ui/field';
import { LANGUAGES } from 'framework/form';
import { Typography } from '@mui/material';

const CandidateNativeLang = () => {
  const { getValue: getLang } = useFieldHelper({ source: 'nativeLanguage' });
  const userLang = getLang();
  if (typeof userLang === 'undefined') {
    return '';
  }
  const currCountry = LANGUAGES && LANGUAGES.find(el => el.name.toLowerCase() === userLang.toLowerCase());
  if (currCountry && currCountry.short) {
    return (
      <Typography
        component="div"
        key={userLang}
        sx={{
          padding: '2px 8px',
          fontSize: '14px',
          fontWeight: 400,
          textAlign: 'center',
          color: 'common.white',
          borderRadius: '3px',
          minWidth: '32px',
          whiteSpace: 'nowrap',
          textTransform: 'uppercase',
          backgroundColor: 'primary.main',
        }}
      >
        {currCountry.short}
      </Typography>
    );
  } else {
    return '';
  }
};

export default CandidateNativeLang;
